export const white = '#FFFFFF'
export const black = '#000000'

// colors defined to conform to accessibility standards
export const accessibilityColors = {
  // use for theme, icons, buttons, links, click actions, sliders, anchorLine etc.
  theme: {
    green: '#158463',
    greenLighter: '#458500',
    greenDarker: '#157A5C',
    blue: '#0074E0',
    blueHover: '#00529E',
    red: '#E0004B',
    white,
    black,
    greyBg: '#F8F8F8',
  },
  border: {
    default: '#000000',
  },
  // use for labels, tags, name icons
  labels: {
    green: {
      text: '#157A5C',
      bg: '#E1FBED',
    },
    blue: {
      text: '#1C64CA',
      bg: '#E0F0FF',
    },
    grey: {
      text: '#3A3F40',
      bg: '#CDD8DA',
    },
    greyBluish: {
      text: '#142D53',
      bg: '#C6D7E7',
    },
    cyan: {
      text: '#0C3A41',
      bg: '#BDDBE0',
    },
    orange: {
      text: '#AF441D',
      bg: '#FFE1D6',
    },
    red: {
      text: '#DA1640',
      bg: '#FDEFF2',
    },
    yellow: {
      text: '#8A6700',
      bg: '#FFF4D6',
    },
  },
  sidebar: {
    bg: '#06141B',
    userInfo: '#253745',
    userInfoDropdown: '#505e6f',
  },
  slider: {
    bg: '#949494',
  },
  anchorLine: {
    text: '#667070',
    bg: '#b9d5fa',
  },
  tabs: {
    grey: {
      text: '#58646A',
      bg: '#E5E5E5',
    },
    newTag: '#C31339',
  },
  table: {
    text: '#434B5D',
    headerBg: '#FAFAFA',
    headerSortedBg: '#E5E5E5',
    rowBg: '#FFFFFF',
    rowBorder: '#E5E5E5',
  },
  legend: {
    text: '#58646A',
  },
  profiles: {
    avatarBackgrounds: [
      '#A3C4F3',
      '#FFD6A5',
      '#CAFFBF',
      '#FFB3C6',
      '#BDB2FF',
      '#FFC6FF',
      '#FDFFB6',
      '#9BF6FF',
    ],
  },
  studentSubmitPage: {
    markedAnswered: '#2A7AB7',
    markedSkipped: '#757575',
    markedForReview: '#A16908',
  },
  testStatus: {
    notOpen: '#4E79A6',
    inProgress: '#2E71E5',
    inGrading: '#B75E06',
    done: '#00853E',
  },
  studentStatus: {
    notStarted: { text: '#4E79A6', bg: '#E5E5E5' },
    inProgress: { text: '#2E71E5', bg: '#BEDEFF' },
    submitted: { text: '#B75E06', bg: '#FFE9A8' },
    absent: { text: '#DE0B83', bg: '#FDE0E9' },
    graded: { text: '#458500', bg: '#DEF4E8' },
    gradesHeld: { text: '#008085' },
    missed: { text: '#9E57BC' },
  },
  testType: {
    assessment: '#458500',
    common: '#B75E06',
    practice: '#2E71E5',
    homework: '#DE0B83',
    quiz: '#873fe5',
    survey: '#8D4F1A',
    adaptive: '#007D65',
  },
  subscriptionPage: {
    yourPlan: '#757575',
    purchaseExpiresOn: '#0A7CAE',
  },
  testLibrary: {
    footerIconText: '#757575',
  },
  videoQuiz: {
    channelTitle: '#6A737F',
  },
  playlistPage: {
    columnTitle: '#6A737F',
  },
  banner: {
    purple: {
      bg: '#8063A1',
      border: '#cbb5e3',
    },
    yellow: {
      bg: '#7D783F',
      border: '#E8BA76',
    },
  },
  likeIcon: {
    red: '#E0004B',
    gray: '#667070',
  },
  // use for select, input, autocomplete etc.
  selectDropdown: {
    bg: '#F8F8F8',
    borderInactive: '#949494',
    borderActive: '#0074E0',
    placeholder: '#707070',
    options: {
      bg: white,
      bgDefault: '#E0F0FF',
      bgHover: '#0074E0',
      bgSelected: '#0074E0',
    },
  },
}

export const fadedBlack = 'rgba(0, 0, 0, 0.65)'
export const fadedBlack1 = '#4b4b4b'
export const fadedBlack2 = '#474747'
export const lightFadedBlack = 'rgba(0, 0, 0, 0.15)'
export const textBlackColor = '#212E3A'
export const lightBlackBoldText = '#454B5B'

export const themeColor = accessibilityColors.theme.green // green
export const themeColorLight = '#42d184' // light green
export const themeColorLight1 = '#3DD29F' // light green
export const themeColorLighter = '#5EB500' // light green
export const themeColorLighter1 = '#E8F7F4'
export const themeColorSecondaryLighter = '#26B96A' // light green
export const themeColorTagsBg = '#D1F9EB'
export const themeColorBreadcrumb = '#69727E'
export const themeLightGrayColor = '#BBBFC4'
export const themeLightGrayBgColor = '#F1F1F1'
export const themeColorBlue = accessibilityColors.theme.blue
export const themeColorHoverBlue = accessibilityColors.theme.blueHover
export const drcThemeColor = themeColorBlue
export const drcWhite = white
export const parcThemeColor = '#666666'
export const parcButtonColor = '#eee'

export const greyThemeDark1 = '#434B5D'
export const greyThemeDark2 = '#878A91'
export const greyThemeDark3 = '#69727e'
export const greyThemeDark4 = '#2F4151'
export const greyThemeDark5 = '#8D929D'
export const greyThemeDark6 = '#97A4C1'
export const greyThemeDark7 = '#ADADAD'
export const greyThemeLight = '#949494'
export const greyLight1 = '#e8e8e8'
export const greyThemeLighter = accessibilityColors.theme.greyBg
export const brownDark = '#964B00'
export const brownDark1 = '#595959'

export const grey = '#dfdfdf'
export const fadedGrey = '#e5e5e5'
export const fadedGrey1 = '#e4e4e4'
export const fadedGrey2 = '#EBEBEB'
export const lightGreySecondary = accessibilityColors.theme.greyBg
export const lightGrey = '#f9f9f9'
export const lightGrey1 = '#f6f6f6'
export const lightGrey2 = '#888787'
export const lightGrey3 = '#f4f3f3'
export const lightGrey4 = '#dbdce0'
export const lightGrey5 = '#8E9AA4'
export const lightGrey6 = '#848993'
export const lightGrey7 = '#949ca4'
export const lightGrey8 = '#dbdbdb'
export const lightGrey9 = '#6a737f'
export const lightGrey10 = '#a6a7aa'
export const lightGrey11 = accessibilityColors.table.text
export const lightGrey12 = '#858585'
export const lightGrey13 = '#607380'
export const lightGrey14 = '#738294'
export const lightGrey15 = '#d4d4d4'
export const lightGrey16 = '#dddddd'
/** Light Grey for modern redesign */
export const lightGrey17 = '#707070'
export const lightGrey18 = '#BABABA'
export const lightGrey19 = '#aeb2b7'
export const lightGrey20 = '#F0F0F0'
export const darkGrey = '#a3a0a0'
export const darkGrey1 = '#b5b5b5'
export const darkGrey2 = '#304050'
export const darkGrey3 = '#505050'
export const darkGrey4 = '#414141'
export const darkGrey5 = '#8E8E8E'
export const darkGrey6 = '#767676'
export const textColor = lightGrey6
export const greyish = '#f3f3f4'
export const greyishDarker1 = '#a7b1c2'
export const greyishDarker2 = '#cccccc'
export const mainBgColor = '#ffffff'
export const greyishBorder = '#B6B6CC'
export const mainTextColor = '#444444'
export const secondaryTextColor = '#434b5d'
export const greyDarken = '#979BA1'
export const tagTextColor = accessibilityColors.labels.grey.text
export const tagsBgColor = accessibilityColors.labels.grey.bg
export const titleColor = darkGrey2
export const greyScoreCardTitleColor = lightGrey11
export const cardTitleColor = lightGrey11
export const linkColor = greyThemeDark3
export const linkColor1 = lightGrey9
export const someGreyColor1 = '#c0c0c0'
export const labelGrey = '#9B9B9B'
export const labelGrey2 = '#a2a2a2'
export const borderGrey = '#E1E1E1'
export const placeholderGray = '#b1b1b1'
export const backgroundGrey = '#F2F2F2'
export const borderGrey2 = '#cbcbcb'
export const borderGrey3 = '#e9e9e9'
export const borderGrey4 = '#dadae4'
export const borderGrey5 = borderGrey
export const backgroundGrey2 = '#FBFBFB'

export const whiteSmoke = '#f5f5f5'

export const separatorColor = '#d6d0d0'
export const dashBorderColor = '#e6e6e6'
export const dashBorderColor1 = '#D0D0D0'
export const dashBorderColorOpacity = '#e6e6e633'
export const dropZoneTitleColor = '#b1b1b1'
export const skippedBarColor = '#6a737f'
export const premiumBg = '#FEB63A'

export const svgMapFillColor = 'rgba(0, 176, 255, 0.19)'
export const svgMapStrokeColor = 'rgba(0, 176, 255, 1)'
export const svgDisabledColor = '#80838b'

export const red = accessibilityColors.theme.red
export const lightRed = '#fbdfe7'
export const lightRed2 = '#f58888'
export const lightRed3 = '#ec0149'
export const ligthRed4 = '#F7CCCB'
export const lightRed5 = '#E55C5C'
export const lightRed6 = '#EFBBBB'
export const lightRed7 = '#EF767A'
export const lightRed8 = '#FD9F8D'
export const darkRed = '#F35F5F'
export const darkRed1 = '#F25782'
export const darkRed2 = '#EB4032'
export const darkRed3 = '#E7BB7F'
export const redDark = '#dd2e44'
export const darkRed4 = '#EF767A'
export const fadedRed = '#fce0e8'
export const deleteRed = '#FF0080'
export const deleteRed2 = '#EF3863'
export const strikeOutHover = '#f7cbcc'
export const fieldRequiredColor = '#e82a83'
export const fieldRequiredColor2 = '#ff0100'
export const fieldRequiredColor3 = '#ff4d4f'

export const confirmationDeleteRed = '#e53334'

export const mainBlueColor = '#00b0ff'
export const blue = '#1774F0'
export const blue1 = '#1f72bf'
export const lightBlue = '#93d8f7'
export const lightBlue1 = '#82CAFA'
export const lightBlue2 = '#e6f7ff'
export const lightBlue3 = '#3793dc'
export const lightBlue4 = '#40a1ee'
export const lightBlue5 = '#91d5dc'
export const lightBlue6 = '#c8e8f6'
export const lightBlue7 = '#4e95f3'
export const lightBlue8 = '#5faef3'
export const lightBlue9 = '#00b2ff'
export const lightBlue10 = themeColorBlue
export const darkBlue = '#0080b9'
export const darkBlue1 = '#157ad8'
export const darkBlue2 = '#3896be'
export const darkBlueSecondary = '#0288d1'
export const blueButton = '#0e93dc'
export const blueBorder = '#40a9ff'
export const alertColor = '#faad14'
export const dangerColor = '#f5222d'
export const fadeBlue = '#9bc5ff80'

export const green = themeColor
export const lightGreen = accessibilityColors.labels.green.bg
export const lightGreen1 = '#62ebbd'
export const lightGreen2 = '#94df5e'
export const lightGreen3 = '#d2fca5'
export const lightGreen4 = '#e1fbed'
export const lightGreen5 = '#00ad50'
export const lightGreen7 = '#6ec88c'
export const lightGreen8 = '#74E27A'
export const lightGreen9 = '#3dd29f'
export const lightGreen10 = '#1ab395'
export const lightGreen11 = '#53B095'
export const lightGreen12 = '#5FAD5A'
export const lightGreen13 = '#CEF5D8'
export const lightGreen14 = '#8ACE94'
export const lightGreen15 = '#A0DDD1'
export const lightGreen16 = '#57BD90'
export const greenDark = '#4aac8b'
export const greenDark1 = '#00b373'
export const greenDark2 = '#1fb58b'
export const greenDark3 = '#27947a'
export const greenDark4 = '#5eb400'
export const greenDark5 = '#00803B'
export const greenDark6 = '#11987D'
export const greenDark7 = '#64C4AE'
export const greenDark8 = '#74B335'
export const greenDarkSecondary = '#057750'
export const greenSecondary = '#4CD43B'
export const fadedGreen = '#c7ead9'
export const fadedGreen1 = '#D8EEE2'
export const fadedGreen2 = '#89CE94'

export const greenPrimary = '#0EB08D'
export const greenThird = '#5eb500'

export const greenSomeWhatDark = '#17a67d'

export const yellow = '#febe00'
export const yellow1 = '#FDCC3B'
export const yellow2 = '#ffd500'
export const yellow3 = '#FDCA40'
export const yellow4 = '#FFDF88'
export const yellow5 = '#E49B0F'

export const orange = '#FFA200'
export const darkOrange = '#F9942D'
export const darkOrange1 = '#EB954B'

export const btnBg = '#277df1'
export const btnBgActive = '#5196f3'
export const btnColor = '#bed8fa'

export const title = '#434B5D'
export const darkTitle = '#292f3c'

export const sectionBorder = '#e6e6e6'

export const tabGrey = '#7C848E'

export const inputBgGrey = '#F8F8FB'
export const redHeart = '#e35783'
export const inputBorder = '#d9d9d9'
export const inputBorder1 = '#b9b9b9'
export const selectColor = '#5a6171'
export const dragDropUploadText = '#b2b2b2'
export const dragDropHighlightText = '#1766CE'

export const cardBg = '#f8f8fb'
export const cardBorder = '#e6e6e6'

export const gray300 = '#BBBBBB'
export const gray600 = '#555555'
// shadows
export const boxShadowDefault = '0px 2px 5px 0px rgba(0, 0, 0, 0.7)'

export const boxShadowColor = '#C9D0DB80'
export const boxShadowColor2 = '#0000001A'
export const boxShadowColor3 = '#00000029'
export const boxShadowColor4 = '#51586829'
export const paginationBoxShadowColor = '#a3a0a033'

// Graph colors
export const greyGraphstroke = '#999'
export const barGrapColor1 = '#1fe3a0'
export const barGrapColor2 = '#ee1b82'
export const incorrect = darkRed
export const pCorrect = '#ebaa28'
export const graded = '#7BC0DF'
export const pointColor = '#4a4a4a'
export const notStarted = '#bfbfbf'

// numberPad button color
export const numBtnColors = {
  color: '#707070',
  borderColor: '#D9D9D9',
  backgroundColor: white,
}

// Sizes
export const smallMobileWidth = '325px'
export const middleMobileWidth = '476px'
export const mobileWidth = '480px'
export const mobileWidthLarge = '575px'
export const mobileWidthMax = '767px'
export const tabletWidth = '768px'
export const desktopWidth = '992px'
export const smallDesktopWidth = '1024px'
export const largeDesktopWidth = '1200px'
export const mediumDesktopExactWidth = '1366px'
export const extraDesktopWidth = '1440px'
export const extraDesktopWidthMax = '1600px'

export const testTypeColor = {
  ...accessibilityColors.testType,
  'common assessment': accessibilityColors.testType.common,
  'school common assessment': accessibilityColors.testType.common,
}

export const authorAssignment = {
  assignmentStatusBg: {
    NOT_OPEN: accessibilityColors.testStatus.notOpen,
    IN_PROGRESS: accessibilityColors.testStatus.inProgress,
    IN_GRADING: accessibilityColors.testStatus.inGrading,
    NOT_GRADED: '#D53434',
    GRADES_HELD: accessibilityColors.testStatus.done,
    SUBMITTED: accessibilityColors.testStatus.inGrading,
    NOT_STARTED: '#6F7680',
    DONE: accessibilityColors.testStatus.done,
  },
  lightBlue: '#12a6e8',
}

export const fadedWhite = '#5196f3'
export const fadedWhite2 = '#FFFFFFB2'
export const fadedBlue = '#BED8FA'

export const eastBaycolor = '#51596a'

export const draftColor = '#f8ac59'
export const publishedColor = themeColor
export const publishStatusColor = '#e8f2ff'

export const backgrounds = {
  default: '#f3f3f3',
  primary: accessibilityColors.theme.greyBg,
}

export const borders = {
  default: '#f2f2f2',
  primary: '#b1b1b1',
  secondary: '#e6e6e6',
  tag: '#e2e2e2',
}

export const highlightColors = {
  blue: '#99c2ff',
  green: '#99ff99',
  orange: '#ff8533',
  yellow: '#ffff80',
  pink: '#ff99bb',
}

export const publisherFont1 = '#8080a7'
export const publisherFont2 = '#434b5d'
export const publisherFont3 = '#8888a4'
export const publisherCollectionBg = '#f3f3f8'
export const publisherItemBankIcon = '#7e3ec4'
export const publisherTestsIcon = '#13CECF'
export const publisherPlaylistIcon = '#1487DB'
export const publisherBorder1 = '#d4d4e5'
export const filterIconColor = '#2f4151'

export const playlistTabLink = '#989BA4'

export const graphTickColor = '#435b5d'

// evaluation colors
export const correctBgColor = '#E1FBED'
export const correctIconColor = '#1C7D5B'
export const wrongBgColor = '#FDEFF2'
export const wrongIconColor = '#DA1640'
export const skippedBgColor = '#f5f5f5'
export const skippedIconColor = '#a7a7a7'
export const partialBgColor = '#fbfae0'
export const partialIconColor = '#bdb956'

export const lightBrown = '#efe3bb'
export const lightSkyBlue = '#b9d5fa'

export const placeholderPrefixColor = '#999999'
export const placeholderTextColor = '#777777'

// Froala tool button colors
export const froalaToolButtonBackgroundColor = '#0098f7' // sky blue color

export const aiGradientColors = {
  color1: '#007d65',
  color2: '#1766ce',
}

export const vqUsageProgressColor = {
  red: '#FF0000',
  orange: '#EDA222',
  green: '#1AB395',
  trailColor: '#d8d8d8',
}

export const aiLinearGradient = `${aiGradientColors.color1} 0%, ${aiGradientColors.color2} 100%`

export const addClarifierHoverBackground = '#3f85e5'
export const addClarifierModalTitleColor = '#323232'
export const deleteClarifierButtonColor = '#a9013a'

export const canvasBaseColor = '#E72429'
export const canvasHoverColor = '#B6191D'
export const cream100 = '#FFFDF4'
export const cream200 = '#FBF6E9'
export const cream300 = '#EDE8D4'
export const cream600 = '#999279'
export const navy900 = '#151D34'
export const gray800 = '#262626'
export const blueSkies800 = '#005584'
export const tangerine400 = '#FF7838'
export const papaya500 = '#FDBA00'
export const chalkboard500 = '#30B684'
export const chalkboard600 = '#20845E'
export const chalkboard100 = '#D3F3E7'
export const chalkboard700 = '#195E44'
export const tangerine = '#FFE8DE'
